import { createFileRoute } from "@tanstack/react-router";
import RunDetailPage from "@/features/workflows/run-detail-page";
import { requireFeatureEnabled } from "@/features/features";

export const Route = createFileRoute("/_admin/workflows/$id/runs/$runId")({
  beforeLoad: () => requireFeatureEnabled("workflows"),
  staticData: {
    breadcrumb: { label: "Run detail" },
  },
  component: function RunDetailRoute() {
    const { id, runId } = Route.useParams();
    return <RunDetailPage workflowId={id} runId={runId} />;
  },
});
